<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <img class="logo-topo" src="@/assets/imgs/icon.png" alt="" /><a
        class="navbar-brand"
        href="#"
        >WebTracking - {{ nomeEmpresa || empresaInfo.nomeEmpresa || ""}}</a
      >
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right ml-auto"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link v-if="this.checkLogin == true" :to="'/login'" class="nav-link v-align"><i class="nc-icon nc-icon nc-circle-09 mr-1 text-weight-bold"> </i> <span class="ml-2 mt-auto mb-auto">{{ username || "Usuário" }}</span></router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="this.checkLogin == true" :to="'/logout'" class="nav-link btn btn-info btn-fill text-white">Logout</router-link>
          </li>
        </ul>
  </div>
    </div>
  </nav>
</template>
<script>
export default {
  props: ['checkLogin','username','nomeEmpresa'],
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      title: "Webtracking",
      empresaInfo: {
        logoEmpresa: "",
        nomeEmpresa: "",
      },
    };
  },
  mounted(){
    this.checkEmpresaInfo();
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    checkEmpresaInfo() {
      let info = JSON.parse(sessionStorage.getItem("empresaInfo"));
      // console.log(info);
      if (info) {
        if (info.hasOwnProperty("LINK")) {
          if (info.LINK != "" && info.LINK != null)
            this.empresaInfo.logoEmpresa = info.LINK;
        }
        if (info.hasOwnProperty("NOME")) {
          if (info.NOME != "" && info.NOME != null)
            this.empresaInfo.nomeEmpresa = info.NOME;
        }
      }
    }
  }
};
</script>
<style >
.logo-topo {
  max-width: 50px;
  margin-right: 20px;
}
a.navbar-brand {
  font-size: 16px !important;
}
.v-align .nc-icon{
  font-size: 40px;
}

.v-align{
   vertical-align: bottom;
}
</style>
